import { BaseUseCase } from "@domains/useCases/UseCaseBase";
class AuthorizeUseCase extends BaseUseCase {
    constructor(Repo) {
        super();
        this.Repo = Repo;
    }
    async fetchResult(req) {
        return await this.Repo.proceedToAuthorize(req);
    }
}
export default AuthorizeUseCase;
